import { render, staticRenderFns } from "./PxOfertaFoto.vue?vue&type=template&id=4e3b132f"
import script from "./PxOfertaFoto.vue?vue&type=script&lang=js"
export * from "./PxOfertaFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports